import {
  addAgent,
  clearAgent,
  loadAllAgent,
  loadAllAgentPaginated,
  loadSingleAgent,
  updateAgent,
} from "@/redux/rtk/features/CRM/agent/agentSlice";
import { Button, Form, Steps } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import CompanyInformation from "./CompanyInformation";
import BillingInformation from "./BillingInformation";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";

export default function UpdateCompany({ data, drawer }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const userId = localStorage.getItem("id");
  const { agent: company, loading: companyLoading } = useSelector(
    (state) => state.agent
  );

  useEffect(() => {
    if (data?.id) {
      dispatch(loadSingleAgent(data.id)).then(() => {
        form.setFieldsValue({
          ...data,
        });
      });
    } else {
      form.resetFields();
    }

    return () => dispatch(clearAgent());
  }, [data, dispatch, form]);

  useEffect(() => {
    dispatch(loadSingleAgent(data?.id));
    return () => {
      clearAgent();
    };
  }, [data?.id, dispatch]);
  const onFinish = async (values) => {
    setLoader(true);
    const formData = {
      ...values,
      companySize: Number(values.companySize),
      annualRevenue: Number(values.annualRevenue),
    };
    let resp;

    // checking if i have id i will hit update or i will hit add
    if (data?.id) {
      resp = await dispatch(updateAgent({ id: data.id, values: formData }));
      if (resp.payload.message === "success") {
        dispatch(loadAllAgent());
      }
    } else {
      resp = await dispatch(addAgent(formData));
    }
    console.log(resp);
    if (resp.payload.message === "success") {
      form.resetFields();
      dispatch(loadAllAgent());
      // Use resp ID if available, otherwise fallback to data.id for updates
      const targetId = resp?.payload?.data?.id || data?.id;
      !drawer ? navigate(`/admin/company/${targetId}`) : "";
    }
    setLoader(false);
  };

  const [current, setCurrent] = useState(0);

  const next = async () => {
    try {
      // Validate fields for the current step before proceeding
      await form.validateFields();
      setCurrent(current + 1);
    } catch (error) {
      console.error(t("form.validationFailed"), error);
    }
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: t("company.companyInformation"),
      content: <CompanyInformation form={form} company={company} />,
    },
    {
      title: t("company.billingInformation"),
      content: <BillingInformation form={form} company={company} />,
    },
  ];

  useEffect(() => {
    if (!data?.companyOwnerId && userId) {
      form.setFieldsValue({
        companyOwnerId: parseInt(userId),
      });
    }
  }, [form, userId, data]);
  return (
    <>
      <UserPrivateComponent
        permission="update-company"
        comment={t("company.updatePermissionDenied")}
        type="update"
      >
        <div className="px-20 py-5">
          <Steps size="small" current={current}>
            {steps.map((item, index) => (
              <Steps.Step key={index} title={item.title} />
            ))}
          </Steps>
        </div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: 50,
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          {/* <div>{steps[current].content}</div> */}
          <div>
            {steps.map((item, index) => (
              <div
                key={index}
                style={{ display: index === current ? "block" : "none" }}
              >
                {item.content}
              </div>
            ))}
          </div>

          <div style={{ marginTop: 24, textAlign: "right" }}>
            {current > 0 && (
              <Button
                className="mb-5"
                style={{ marginRight: 8 }}
                onClick={prev}
              >
                {t("common.previous")}
              </Button>
            )}
            {current < steps.length - 1 && (
              <Button type="primary" className="mb-5" onClick={next}>
                {t("common.next")}
              </Button>
            )}
            {current === steps.length - 1 && (
              <Button
                className="mb-5"
                type="primary"
                htmlType="submit"
                loading={loader}
              >
                {t("common.submit")}
              </Button>
            )}
          </div>
        </Form>
      </UserPrivateComponent>
    </>
  );
}
